import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ParentSectionComponent } from './parent-section/parent-section.component';
import { ChildrenSectionComponent } from './children-section/children-section.component';
import { MergeSectionComponent } from './merge-section/merge-section.component';
import { Subscription } from 'rxjs';
import { AppState } from '@app/Store';
import { Store } from '@ngrx/store';

@Component({
    selector: 'app-relations-tab',
    templateUrl: './relations-tab.component.html',
    styleUrls: ['./relations-tab.component.scss'],
})
export class RelationsTabComponent implements OnInit, OnDestroy, AfterViewInit {
    public parentsExpanded: boolean = true;
    public childrenExpanded: boolean = true;
    public mergedExpanded: boolean = true;

    @ViewChild(ParentSectionComponent) parentSection!: ParentSectionComponent;
    @ViewChild(ChildrenSectionComponent) childrenSection!: ChildrenSectionComponent;
    @ViewChild(MergeSectionComponent) mergeSection!: MergeSectionComponent;

    private subscription: Subscription = new Subscription();
    private updateInterval: NodeJS.Timeout;

    constructor(private store: Store<AppState>, private cdr: ChangeDetectorRef) {}

    ngOnInit(): void {
        // Component initialization
    }

    ngAfterViewInit(): void {
        // Periodically check for data updates
        this.updateInterval = setInterval(() => {
            this.cdr.detectChanges();
        }, 500);
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
        }
    }

    public toggleParents(): void {
        this.parentsExpanded = !this.parentsExpanded;
    }

    public toggleChildren(): void {
        this.childrenExpanded = !this.childrenExpanded;
    }

    public toggleMerged(): void {
        this.mergedExpanded = !this.mergedExpanded;
    }
}
